import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { GenericDialog } from 'app/components/Alerts/GenericDialog';
import React from 'react';

const useStyles = makeStyles()(() => ({
  dialogContainer: {
    width: '500px',
    maxWidth: '500px',
  },
}));

interface SsnErrorDialogProps {
  open: boolean;
  title: string;
  message: string;
  onClose: () => void;
}

export const SsnErrorDialog = ({ open, title, message, onClose }: SsnErrorDialogProps) => {
  const { classes } = useStyles();

  return (
    <GenericDialog
      variant="white"
      fullWidth
      classes={{
        paper: classes.dialogContainer,
      }}
      open={open}
      draggable
      dialogTitleProps={{
        text: title,
        closeButton: true,
      }}
      dialogActions={[
        {
          onClick: onClose,
          text: 'Close',
          variant: 'contained',
          color: 'primary',
        },
      ]}
      onClose={() => onClose?.()}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {message}
        </Grid>
      </Grid>
    </GenericDialog>
  );
};
